import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import {
  TransactionSuccessQuery,
  TransactionSuccessService,
  PopulationQuery,
  CustomFieldValidationType,
  DATE_OPTIONS,
  MarketplaceBasketCustomFieldModel,
  LottoDetails,
} from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-lottos-success-page',
  templateUrl: './lottos-success-page.component.html',
  styleUrls: ['./lottos-success-page.component.scss'],
})
export class LottosSuccessPageComponent implements OnInit, OnDestroy {
  public lottoItem: LottoDetails;
  public customFields: MarketplaceBasketCustomFieldModel[] = [];
  public totalPrice: number;
  public quantity: number;
  populations = Populations;
  isCorporate: boolean;

  private readonly transactionSuccessQuery = inject(TransactionSuccessQuery);
  private readonly transactionSuccessService = inject(TransactionSuccessService);
  readonly dateOptions = inject(DATE_OPTIONS);
  readonly customValidationType = CustomFieldValidationType;

  constructor(private populationQuery: PopulationQuery) {}

  ngOnInit() {
    const transaction = this.transactionSuccessQuery.getValue();
    this.lottoItem = transaction.item as LottoDetails;
    this.customFields = transaction.customFields || [];
    this.totalPrice = transaction.totalPrice;
    this.quantity = transaction.quantity;
    this.isCorporate = this.populationQuery.userInPopulation([this.populations.Hospitality]);
  }

  ngOnDestroy(): void {
    this.transactionSuccessService.clear();
  }
}
